import React, { useState } from "react";
import UserHeader from "./UserHeader";
import UseSidebar from "./UseSidebar";
import Footer from "../core/Footer";

const UserLayout = ({ children }) => {
  const [isTrue, setIsTrue] = useState(false);

  const pathname = window.location.pathname;

  const handleChildrenCallback = (menuIsActive) => {
    setIsTrue(menuIsActive);
  };

  const getAttribute = () => {
    switch (pathname) {
      case "/user/profile":
        return "profile-page";
      case "/user/accountSettings":
        return "profile-page";
      case "/user/notifications":
        return "mynetwork-page";
      case "/admin":
        return "profile-page";
      case "/user/analytics":
        return "analytics-page";
      case "/user/network":
        return "mynetwork-page";
      case "/user/my-connections":
        return "mynetwork-page";
      case "/user/performance":
        return "performance-page";
      default:
        return "dashboard-page";
    }
  };
  return (
    <>
      <div
        className={
          isTrue
            ? "dashboard-page sidebar-active"
            : `dashboard-page ${getAttribute()}`
        }
      >
        <UserHeader parentCallback={handleChildrenCallback}></UserHeader>
        <main>
          <section className="dashboard-wrap">
            <div className="container">
              <UseSidebar menuActive={isTrue}></UseSidebar>
              {children}
            </div>
          </section>
        </main>
      </div>
  
        <Footer></Footer>
    </>
  );
};

export default UserLayout;
